<tt-list ttHeightFull [ttData]="customers" [ttBadge]="page?.show_badgeinfo === '1' ? 'badgeinfo' : ''"></tt-list>
